import EmailMultiChoiceInput from "../../../../project/EmailResponseSetting/EmailMultiChoiceInput";

function ContentEmailAddress({
    fieldData,
    address,
    setAddress,
    listSuggestSearchEmail,
    disabled=false,
    required=false,
    isEditedCurrentTicket,
    setIsEditedCurrentTicket
}) {
    return (
        <div className='form-addTicket'>
            <div className="cell-prod-status gap-8">
                <label class="form-addTicket-label">{fieldData?.name?.jp?.text}</label>
                {required && <span className="required">*</span>}
            </div>
            <div className="email-response-address-input-wrap" style={{width: '100%'}}>
                <EmailMultiChoiceInput
                    disable={disabled}
                    addressList={address}
                    setAddressList={setAddress}
                    listSuggestSearchEmail={listSuggestSearchEmail}
                    required={required}
                    setIsEdited={setIsEditedCurrentTicket}
                    triggerClearError={isEditedCurrentTicket === false}
                />
            </div>
        </div>
    )
}

export default ContentEmailAddress;
